
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  return new URL($parcel$distDir + url, import.meta.url).toString();
}

      var $parcel$global = globalThis;
    var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree32c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree32c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
var $3f60fad17a2ec951$exports = {};
$parcel$extendImportMap({
    "4yYkC": "OfficeDay.82ccaeec.jpeg",
    "bRsOv": "OfficeDay.a3162a07.jpeg",
    "4fBDf": "OfficeNight.d410d0cb.jpeg",
    "3aqkI": "OfficeNight.f5c0b663.jpeg",
    "fxtCj": "ModernHouse.ce0846d6.jpeg",
    "lTTTj": "ModernHouse.74aef757.jpeg",
    "7Jt65": "ModernHouseOverlay.763bf559.jpeg",
    "aTUmO": "ModernHouseOverlay.749a66d9.jpeg",
    "9y6tJ": "FactoryIso.a7ce025c.png",
    "2TlGM": "FactoryInterior.3a45ee59.jpeg",
    "lXUJw": "FactoryInterior.defcbc3f.jpeg",
    "dFuay": "house_exploded.fcf98be1.jpeg",
    "1X2a7": "house_exploded.4f18b651.jpeg",
    "3StBd": "house_pieces.dd8c5e4f.jpeg",
    "lMmn3": "house_pieces.1ab2428a.jpeg",
    "caODR": "3d Prints.f787ca5d.jpeg",
    "fNdwO": "3d Prints.b1f21004.jpeg",
    "fVjoo": "BackyardCircleRender.c7fcfac8.png",
    "liGso": "BackyardWire.1107a658.jpeg",
    "hJ37w": "BackyardWire.f9ede145.jpeg",
    "8yffQ": "padoga_render.3da968a2.jpeg",
    "fcUjp": "padoga_render.0718bf6a.jpeg",
    "bZC8M": "Building1.be34e131.png",
    "9mvR1": "FactoryIso.1f62b675.webp",
    "bBJem": "BackyardCircleRender.5c77be20.webp",
    "8aaN8": "Building1.769edb7b.webp"
});


var $7d6cd4afa7fffaf2$exports = {};
'use strict';
Object.defineProperty($7d6cd4afa7fffaf2$exports, '__esModule', {
    value: true
});
function $7d6cd4afa7fffaf2$var$hyper(h) {
    var children = [];
    for(var _i = 1; _i < arguments.length; _i++)children[_i - 1] = arguments[_i];
    var parts = h.split(/(?=[.#])/);
    var tag = "div";
    if (parts[0][0] !== "#" && parts[0][0] !== ".") {
        tag = parts[0];
        parts = parts.slice(1);
    }
    var elem = document.createElement(tag);
    for(var i = 0; i < parts.length; i++)switch(parts[i][0]){
        case "#":
            elem.setAttribute("id", parts[i].substr(1));
            break;
        case ".":
            elem.classList.add(parts[i].substr(1));
            break;
    }
    function handleChildren(children) {
        children.forEach(function(child) {
            if (Array.isArray(child)) handleChildren(child);
            else if (child instanceof Node) elem.appendChild(child);
            else if (typeof child === "object") for(var key in child){
                var item = child[key];
                if (typeof item === "string") elem.setAttribute(key, item);
            }
            else if (typeof child === "string" || typeof child === "number") elem.appendChild(document.createTextNode(child.toString()));
        });
    }
    handleChildren(children);
    return elem;
}
var $7d6cd4afa7fffaf2$var$leftArrow = '<svg width="200" height="200" viewBox="0 0 52.917 52.917" xmlns="http://www.w3.org/2000/svg"><path style="fill:none;stroke:#000;stroke-width:8.66;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="M37.042 5.292 15.875 26.458l21.167 21.167"/></svg>';
var $7d6cd4afa7fffaf2$var$rightArrow = '<svg width="200" height="200" viewBox="0 0 52.917 52.917" xmlns="http://www.w3.org/2000/svg"><path style="fill:none;stroke:#000;stroke-width:8.66;stroke-linecap:round;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m15.875 5.292 21.167 21.166-21.167 21.167"/></svg>';
var $7d6cd4afa7fffaf2$var$xIcon = '<svg width="50" height="50" viewBox="0 0 13.229 13.229" xmlns="http://www.w3.org/2000/svg"><path style="fill:none;stroke:#000;stroke-width:2;stroke-linecap:butt;stroke-linejoin:bevel;stroke-miterlimit:4;stroke-dasharray:none;stroke-opacity:1" d="m2.646 10.583 7.937-7.937"/><path style="fill:none;stroke:#000;stroke-width:2;stroke-linecap:butt;stroke-linejoin:bevel;stroke-opacity:1;stroke-miterlimit:4;stroke-dasharray:none" d="M10.583 10.583 2.646 2.646"/></svg>';
var $7d6cd4afa7fffaf2$var$TRANSITION_TIME = 500;
function $7d6cd4afa7fffaf2$var$createGalleryView() {
    var viewer = $7d6cd4afa7fffaf2$var$hyper("div.viewer.hidden", $7d6cd4afa7fffaf2$var$hyper("div.viewer-overlay"), $7d6cd4afa7fffaf2$var$hyper("div.viewer-box", $7d6cd4afa7fffaf2$var$hyper("div.viewer-back.hidden", $7d6cd4afa7fffaf2$var$hyper("a", {
        href: "#"
    })), $7d6cd4afa7fffaf2$var$hyper("div.viewer-contents", $7d6cd4afa7fffaf2$var$hyper("div.img-container"), $7d6cd4afa7fffaf2$var$hyper("div.img-description", $7d6cd4afa7fffaf2$var$hyper("div.desc-text"), $7d6cd4afa7fffaf2$var$hyper("div.close-icon", $7d6cd4afa7fffaf2$var$hyper("a", {
        href: "#"
    }))), $7d6cd4afa7fffaf2$var$hyper("div.loading-spinner", $7d6cd4afa7fffaf2$var$hyper("div.lds-ellipsis", $7d6cd4afa7fffaf2$var$hyper("div"), $7d6cd4afa7fffaf2$var$hyper("div"), $7d6cd4afa7fffaf2$var$hyper("div"), $7d6cd4afa7fffaf2$var$hyper("div")))), $7d6cd4afa7fffaf2$var$hyper("div.viewer-forward.hidden", $7d6cd4afa7fffaf2$var$hyper("a", {
        href: "#"
    }))));
    var leftArrowSVG = $7d6cd4afa7fffaf2$var$leftArrow.replace("stroke:#000", "").replace("width=\"200\"", "").replace("height=\"200\"", "");
    var rightArrowSVG = $7d6cd4afa7fffaf2$var$rightArrow.replace("stroke:#000", "").replace("width=\"200\"", "").replace("height=\"200\"", "");
    var viewerBack = viewer.querySelector(".viewer-back");
    var viewerForward = viewer.querySelector(".viewer-forward");
    viewerBack.firstElementChild.innerHTML = leftArrowSVG;
    viewerForward.firstElementChild.innerHTML = rightArrowSVG;
    var viewerOverlay = viewer.querySelector(".viewer-overlay");
    viewerOverlay.addEventListener("click", function() {
        hide();
    });
    var viewerContents = viewer.querySelector(".viewer-contents");
    var imgContainer = viewer.querySelector(".img-container");
    var imgDescElem = viewer.querySelector(".img-description");
    var descTextElem = imgDescElem.querySelector(".desc-text");
    var closeButtonElem = imgDescElem.querySelector(".close-icon a");
    closeButtonElem.addEventListener("click", function(ev) {
        ev.preventDefault();
        hide();
    });
    closeButtonElem.innerHTML = $7d6cd4afa7fffaf2$var$xIcon.replace("stroke:#000", "").replace("stroke:#000", "").replace("width=\"50\"", "").replace("height=\"50\"", "");
    var loadedImage = new Image();
    imgContainer.appendChild(loadedImage);
    var imgDimensions = {
        width: 1,
        height: 1
    };
    var imageFadeTimeout;
    function loadImg(img) {
        loadedImage = new Image();
        loadedImage.src = img.src;
        viewerContents.classList.add("loading");
        descTextElem.innerText = img.desc || "";
        var startTime = Date.now();
        loadedImage.onload = function() {
            imgDimensions.width = loadedImage.width;
            imgDimensions.height = loadedImage.height;
            resizeView();
            var remainingTime = Math.max($7d6cd4afa7fffaf2$var$TRANSITION_TIME, $7d6cd4afa7fffaf2$var$TRANSITION_TIME - (Date.now() - startTime));
            clearTimeout(imageFadeTimeout);
            imageFadeTimeout = setTimeout(function() {
                viewerContents.classList.remove("loading");
                imgContainer.firstChild.replaceWith(loadedImage);
            }, remainingTime);
        };
    }
    function resizeView() {
        var imgRatio = imgDimensions.height > 0 ? imgDimensions.width / imgDimensions.height : 1;
        var screenRatio = window.innerWidth / window.innerHeight;
        if (imgRatio > screenRatio) {
            var targetWidth = Math.round(window.innerWidth * 0.8);
            var targetHeight = Math.round(targetWidth * (1 / imgRatio));
            imgContainer.style.width = "".concat(targetWidth, "px");
            imgContainer.style.height = "".concat(targetHeight, "px");
            imgDescElem.style.width = "".concat(targetWidth, "px");
        } else {
            var targetHeight = Math.round(window.innerHeight * 0.8);
            var targetWidth = Math.round(targetHeight * imgRatio);
            imgContainer.style.height = "".concat(targetHeight, "px");
            imgContainer.style.width = "".concat(Math.round(targetHeight * imgRatio), "px");
            imgDescElem.style.width = "".concat(targetWidth, "px");
        }
    }
    document.body.appendChild(viewer);
    window.addEventListener("resize", function() {
        resizeView();
    });
    var imageSet = [];
    var imageSetIndex = 0;
    viewerBack.firstElementChild.addEventListener("click", function(ev) {
        ev.preventDefault();
        prevImage();
    });
    viewerForward.firstElementChild.addEventListener("click", function(ev) {
        ev.preventDefault();
        nextImage();
    });
    var updateArrowVis = function() {
        if (imageSetIndex === 0) viewerBack.classList.add("hidden");
        else viewerBack.classList.remove("hidden");
        if (imageSetIndex === imageSet.length - 1) viewerForward.classList.add("hidden");
        else viewerForward.classList.remove("hidden");
    };
    var nextImage = function() {
        var newIndex = imageSetIndex + 1;
        if (newIndex < imageSet.length) {
            imageSetIndex = newIndex;
            loadImg(imageSet[imageSetIndex]);
            updateArrowVis();
        }
    };
    var prevImage = function() {
        var newIndex = imageSetIndex - 1;
        if (newIndex >= 0) {
            imageSetIndex = newIndex;
            loadImg(imageSet[imageSetIndex]);
            updateArrowVis();
        }
    };
    resizeView();
    var loadSet = function(setItems, index) {
        if (index === void 0) index = 0;
        viewer.classList.remove("hidden");
        imageSet = setItems;
        imageSetIndex = index;
        loadImg(imageSet[imageSetIndex]);
        updateArrowVis();
    };
    var hide = function() {
        viewer.classList.add("hidden");
    };
    return {
        elem: viewer,
        next: nextImage,
        prev: prevImage,
        loadSet: loadSet,
        hide: hide
    };
}
$7d6cd4afa7fffaf2$exports.createGalleryView = $7d6cd4afa7fffaf2$var$createGalleryView;


const $56691c85c048e1af$var$app = document.querySelector("#app");
const $56691c85c048e1af$var$header = $56691c85c048e1af$var$app.querySelector(".header");
const $56691c85c048e1af$var$navbar = $56691c85c048e1af$var$app.querySelector(".navbar");
const $56691c85c048e1af$var$titleLink = $56691c85c048e1af$var$header.querySelector("a");
const $56691c85c048e1af$var$aboutLink = $56691c85c048e1af$var$navbar.querySelector(".about-link a");
const $56691c85c048e1af$var$worksLink = $56691c85c048e1af$var$navbar.querySelector(".works-link a");
const $56691c85c048e1af$var$pages = $56691c85c048e1af$var$app.querySelector(".pages");
let $56691c85c048e1af$var$pageIndex = 0;
function $56691c85c048e1af$var$setPageClasses(index) {
    $56691c85c048e1af$var$pages.classList.remove("page-0");
    $56691c85c048e1af$var$pages.classList.remove("page-1");
    $56691c85c048e1af$var$pages.classList.remove("page-2");
    $56691c85c048e1af$var$pages.classList.remove("page-3");
    $56691c85c048e1af$var$pages.classList.add("page-" + index);
}
function $56691c85c048e1af$var$selectPage(index) {
    if (index === 0) {
        $56691c85c048e1af$var$header.classList.remove("minimize");
        $56691c85c048e1af$var$setPageClasses(index);
    } else {
        $56691c85c048e1af$var$setPageClasses(index);
        $56691c85c048e1af$var$header.classList.add("minimize");
    }
    $56691c85c048e1af$var$pageIndex = index;
}
$56691c85c048e1af$var$titleLink.addEventListener("click", (ev)=>{
    //ev.preventDefault();
    $56691c85c048e1af$var$selectPage(0);
});
$56691c85c048e1af$var$aboutLink.addEventListener("click", (ev)=>{
    //ev.preventDefault();
    $56691c85c048e1af$var$selectPage(1);
});
$56691c85c048e1af$var$worksLink.addEventListener("click", (ev)=>{
    //ev.preventDefault();
    $56691c85c048e1af$var$selectPage(2);
});
window.onpopstate = ()=>{
    $56691c85c048e1af$var$updatePageLocation();
};
function $56691c85c048e1af$var$updatePageLocation() {
    $56691c85c048e1af$var$galleryView.hide();
    switch(document.location.hash){
        case "":
            $56691c85c048e1af$var$selectPage(0);
            break;
        case "#about":
            $56691c85c048e1af$var$selectPage(1);
            break;
        case "#works":
            $56691c85c048e1af$var$selectPage(2);
            break;
    }
}
const $56691c85c048e1af$var$previewClose = $56691c85c048e1af$var$app.querySelector(".preview-close");
var $f99da6b7c565dc6e$exports = {};
$f99da6b7c565dc6e$exports = $parcel$resolve("4yYkC");


var $d32257c06e44edc0$exports = {};
$d32257c06e44edc0$exports = $parcel$resolve("bRsOv");


var $b7405c089110ac34$exports = {};
$b7405c089110ac34$exports = $parcel$resolve("4fBDf");


var $27041db43cf720ac$exports = {};
$27041db43cf720ac$exports = $parcel$resolve("3aqkI");


var $db6dd27d94c99f4c$exports = {};
$db6dd27d94c99f4c$exports = $parcel$resolve("fxtCj");


var $8e51d55593943532$exports = {};
$8e51d55593943532$exports = $parcel$resolve("lTTTj");


var $b1b69b494704118c$exports = {};
$b1b69b494704118c$exports = $parcel$resolve("7Jt65");


var $a5ae77ff77dcbbac$exports = {};
$a5ae77ff77dcbbac$exports = $parcel$resolve("aTUmO");


var $377c950a12833edd$exports = {};
$377c950a12833edd$exports = $parcel$resolve("9y6tJ");


var $7ee9f5574119e65b$exports = {};
$7ee9f5574119e65b$exports = $parcel$resolve("9mvR1");


var $afd291e31355c070$exports = {};
$afd291e31355c070$exports = $parcel$resolve("2TlGM");


var $eaec05435801f88d$exports = {};
$eaec05435801f88d$exports = $parcel$resolve("lXUJw");


var $4b3002b350efeefa$exports = {};
$4b3002b350efeefa$exports = $parcel$resolve("dFuay");


var $506a81446e6ee834$exports = {};
$506a81446e6ee834$exports = $parcel$resolve("1X2a7");


var $f3e6605ca1f2b72b$exports = {};
$f3e6605ca1f2b72b$exports = $parcel$resolve("3StBd");


var $edfc644ed319e427$exports = {};
$edfc644ed319e427$exports = $parcel$resolve("lMmn3");


var $166d05f83427bd3f$exports = {};
$166d05f83427bd3f$exports = $parcel$resolve("caODR");


var $d6606ccf7b275a2c$exports = {};
$d6606ccf7b275a2c$exports = $parcel$resolve("fNdwO");


var $f21ef1e4167a5794$exports = {};
$f21ef1e4167a5794$exports = $parcel$resolve("fVjoo");


var $a82cdee036adba40$exports = {};
$a82cdee036adba40$exports = $parcel$resolve("bBJem");


var $2a365d16fab099f8$exports = {};
$2a365d16fab099f8$exports = $parcel$resolve("liGso");


var $50b4e1495bf575ec$exports = {};
$50b4e1495bf575ec$exports = $parcel$resolve("hJ37w");


var $ba6c534e1745909d$exports = {};
$ba6c534e1745909d$exports = $parcel$resolve("8yffQ");


var $081463534e9a5381$exports = {};
$081463534e9a5381$exports = $parcel$resolve("fcUjp");


var $947af1f22fd5329b$exports = {};
$947af1f22fd5329b$exports = $parcel$resolve("bZC8M");


var $90e9424a0de867bb$exports = {};
$90e9424a0de867bb$exports = $parcel$resolve("8aaN8");


const $56691c85c048e1af$var$images = {
    officeDay: {
        thumb: new URL($f99da6b7c565dc6e$exports).toString(),
        src: new URL($d32257c06e44edc0$exports).toString(),
        desc: "Daytime office render using Blender."
    },
    officeNight: {
        thumb: new URL($b7405c089110ac34$exports).toString(),
        src: new URL($27041db43cf720ac$exports).toString(),
        desc: "Nighttime office render using Blender."
    },
    modernHouse: {
        thumb: new URL($db6dd27d94c99f4c$exports).toString(),
        src: new URL($8e51d55593943532$exports).toString(),
        desc: "A modern house modelled in Sketchup using an image found online, and rendered using SUPodium for Sketchup."
    },
    modernHouseOverlay: {
        thumb: new URL($b1b69b494704118c$exports).toString(),
        src: new URL($a5ae77ff77dcbbac$exports).toString(),
        desc: "An overlay of the house render overtop of the original house photo."
    },
    factoryIso: {
        thumb: new URL($377c950a12833edd$exports).toString(),
        src: new URL($7ee9f5574119e65b$exports).toString(),
        desc: "An isometric view of a factory designed and modeled in AutoCAD and Revit, and rendered in Blender."
    },
    factoryInterior: {
        thumb: new URL($afd291e31355c070$exports).toString(),
        src: new URL($eaec05435801f88d$exports).toString(),
        desc: "An interior render of a factory designed and modeled in AutoCAD and Revit, and rendered in Blender. "
    },
    houseExploded: {
        thumb: new URL($4b3002b350efeefa$exports).toString(),
        src: new URL($506a81446e6ee834$exports).toString(),
        desc: "An exploded view of a 3D print model of a house."
    },
    housePieces: {
        thumb: new URL($f3e6605ca1f2b72b$exports).toString(),
        src: new URL($edfc644ed319e427$exports).toString(),
        desc: "The 3D printed pieces of a house modelled in Sketchup."
    },
    prints3D: {
        thumb: new URL($166d05f83427bd3f$exports).toString(),
        src: new URL($d6606ccf7b275a2c$exports).toString(),
        desc: "A bunch of different models I 3D printed with a coin for scale."
    },
    backyardRender: {
        thumb: new URL($f21ef1e4167a5794$exports).toString(),
        src: new URL($a82cdee036adba40$exports).toString(),
        desc: "A 3D render of a model of stumps I created using photogrammetry."
    },
    backyardWire: {
        thumb: new URL($2a365d16fab099f8$exports).toString(),
        src: new URL($50b4e1495bf575ec$exports).toString(),
        desc: "A wireframe render of a photoscan captured using Meshroom."
    },
    padogaRender: {
        thumb: new URL($ba6c534e1745909d$exports).toString(),
        src: new URL($081463534e9a5381$exports).toString(),
        desc: "A 3D render of a Padoga model I created for the chinese new year."
    },
    buildingElevation: {
        thumb: new URL($947af1f22fd5329b$exports).toString(),
        src: new URL($90e9424a0de867bb$exports).toString(),
        desc: "An accurate to scale photo-elevation of an existing building."
    }
};
const $56691c85c048e1af$var$imageIds = $56691c85c048e1af$var$app.querySelectorAll("img[data-gallery-id]");
const $56691c85c048e1af$var$galleryView = (0, $7d6cd4afa7fffaf2$exports.createGalleryView)();
const $56691c85c048e1af$var$imageSets = {};
$56691c85c048e1af$var$imageIds.forEach((imageElem)=>{
    const group = imageElem.dataset.group;
    if (!$56691c85c048e1af$var$imageSets[group]) $56691c85c048e1af$var$imageSets[group] = [];
    const index = $56691c85c048e1af$var$imageSets[group].length;
    $56691c85c048e1af$var$imageSets[group].push($56691c85c048e1af$var$images[imageElem.dataset.galleryId]);
    imageElem.addEventListener("click", ()=>{
        $56691c85c048e1af$var$galleryView.loadSet($56691c85c048e1af$var$imageSets[group], index);
    });
});
const $56691c85c048e1af$var$demoButton = document.getElementById("demo-button");
if ($56691c85c048e1af$var$demoButton) $56691c85c048e1af$var$demoButton.addEventListener("click", (ev)=>{
    ev.preventDefault();
    const elem = document.querySelector("img[data-gallery-id=officeDay]");
    if (elem) elem.click();
});
$56691c85c048e1af$var$updatePageLocation();


//# sourceMappingURL=app.5b82b4a2.js.map
